import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  bus: [],
  iranOut: [],
  insideiran:[],
  hotel:[],
  train:[]
};

const FaqSlice = createSlice({
  name: "Faq",
  initialState,

  reducers: {
    setFaq: (state, action) => {
      state.bus = action.payload.bus;
      state.iranOut = action.payload.iranOut;
      state.insideiran = action.payload.insideiran;
      state.hotel = action.payload.hotel;
      state.train = action.payload.train;
    },
  },
});

export const {setFaq} = FaqSlice.actions;

export const selectBus = (state) => state.Faq.bus;
export const selectIranOut = (state) => state.Faq.iranOut;
export const selectInsideIran = (state) => state.Faq.insideiran;
export const selectHotel = (state) => state.Faq.hotel;
export const selectTrain = (state) => state.Faq.train;


export default FaqSlice.reducer;